import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=701c42ca&scoped=true&"
import script from "./curriculum.vue?vue&type=script&lang=js&"
export * from "./curriculum.vue?vue&type=script&lang=js&"
import style0 from "./curriculum.vue?vue&type=style&index=0&id=701c42ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c42ca",
  null
  
)

export default component.exports